import {
  CreateSchoolAdminRequest,
  SaveOnboardingRequest,
  SchoolAdminsIdsListRequest,
  UpdateSchoolAdminRequest
} from "../../../../types/gqlTypes/graphql"
import { executeMutationSideload } from "../../helpers/studyPlan"
import {
  CREATE_SCHOOL_ADMIN,
  SCHOOL_ADMIN_SAVE_ONBOARDING,
  DELETE_SCHOOL_ADMINS,
  UPDATE_SCHOOL_ADMIN
} from "./orgSchoolAdminMutations"

export async function createSchoolAdmin(
  data: CreateSchoolAdminRequest
): Promise<boolean> {
  return await executeMutationSideload(CREATE_SCHOOL_ADMIN, { data })
}

export async function updateSchoolAdmin(
  data: UpdateSchoolAdminRequest
): Promise<boolean> {
  return await executeMutationSideload(UPDATE_SCHOOL_ADMIN, { data })
}

export function deleteSchoolAdmins(
  data?: SchoolAdminsIdsListRequest
): Promise<boolean> {
  return executeMutationSideload(DELETE_SCHOOL_ADMINS, { data })
}

export function schoolAdminSaveOnboarding(
  data?: SaveOnboardingRequest
): Promise<boolean> {
  return executeMutationSideload(SCHOOL_ADMIN_SAVE_ONBOARDING, { data })
}
